<template>
  <MainHeader
    :is-avatar-popover-open="isAvatarPopoverOpen"
    :dark-mode="darkMode"
    :forbidden-mode="disabled"
    :expanded-sidebar="internalExpandedSidebar"
    :notifications="notifications"
    :infos-user="[]"
    :user="user"
    @toggle-sidebar="internalExpandedSidebar = !internalExpandedSidebar"
    @clear-notifications="clearNotifications()"
    @disconnect="disconnect()"
    @read-notification="readNotification($event)"
    @avatar-popover-toggle="isAvatarPopoverOpen = $event"
  >
    <template
      v-if="!disabled"
      #additional-left-avatar
    >
      <div
        v-if="$store.state.etablissementActuel?.value > -1"
        class="etab-actuel"
      >
        <span class="country">{{ $store.state.etablissementActuel.pays.toLowerCase() }}</span>
        <span class="separator">-</span>
        <span>{{ $store.state.etablissementActuel.label }}</span>
        <ButtonClassic
          variant="special"
          color="primary"
          size="small"
          icon="left"
          @click="askBeforeClearEtabActuel()"
        >
          <template #left-icon>
            <UilTimes />
          </template>
        </ButtonClassic>
      </div>
      <ModalConfirmationSupprEtab
        @confirm="clearEtablissementActuel"
      />
      <ButtonGroupHeader :dark-mode="darkMode" />
    </template>
  </MainHeader>
</template>

<script>
import { ButtonClassic, MainHeader } from "@lde/core_lde_vue";

import { UilTimes } from "@iconscout/vue-unicons";

import ButtonGroupHeader from "@/components/buttons/ButtonGroupHeader.vue";

import ModalConfirmationSupprEtab from "@/components/modals/ModalConfirmationSupprEtab.vue";

import config from "@/config";

import { mapGetters } from "vuex";

/**
 * Affiche le header du site. Celui-ci regroupe de nombreux composants accessibles de partout.
 */
export default {
  name: "Header", // eslint-disable-line
  components: {
    ButtonClassic,
    ButtonGroupHeader,
    MainHeader,
    ModalConfirmationSupprEtab,
    UilTimes,
  },
  props: {
    /**
     * Si le site est en dark mode.
     */
    darkMode: {
      type: Boolean,
      default: false,
    },
    /**
     * Désactive les actions possibles.
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Agrandit ou réduit le menu de gauche.
     */
    expandedSidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fetchingInterval: null,
      isAvatarPopoverOpen: false,
      notifications: {},
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "organismeActuel",
      "hasPerm",
      "hasPerms",
      "country",
    ]),
    internalExpandedSidebar: {
      get() {
        return this.expandedSidebar;
      },
      set(newVal) {
        this.$emit("change-expanded-sidebar", newVal);
      },
    },
    service() {
      return {
        url: this.country === "de" ? config.urlDe.hub : config.urlFr.hub,
        nom: this.$t("general.retour-vers-hub"),
        // eslint-disable-next-line global-require
        image: require("@lde/core_lde_vue/dist/assets/media/logos/logo_lde_squares.svg"),
      };
    },
  },
  mounted() {
    document.getElementById("avatar_button").remove();
  },
  methods: {
    askBeforeClearEtabActuel() {
      this.$modal.show("modal_confirmation_suppr_etab");
    },
    clearEtablissementActuel() {
      this.$store.dispatch("setEtablissementActuel", null);

      // On force le retour à la racine pour éviter toute réinjection
      // de l'établissement via les params/query d'URL.
      const hasQuery = Object.keys(this.$route.query || {}).length > 0;
      const hasParams = Object.keys(this.$route.params || {}).length > 0;
      const shouldRedirectHome = this.$route.path !== "/" || hasQuery || hasParams;

      if (shouldRedirectHome) {
        this.$router.replace({ path: "/" }).catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss">
@use "~@lde/core_lde_vue/dist/assets/styles/_variables.scss" as var;
@use "~@lde/core_lde_vue/dist/assets/styles/_fonts.scss" as font;

#main_header {
  .button-service {
    flex-direction: row-reverse;
    margin-bottom: var.$space-x-tiny;
    padding: var.$space-x-tiny var.$space-tiny;
    box-shadow: none;

    .name { @include font.text-regular; }

    img {
      margin-right: 0;
      margin-left: var.$space-x-tiny;
      width: var.$space-medium;
      height: var.$space-medium;
    }
  }

  > .button-classic:first-of-type {
    margin-right: var.$space-tiny;
  }

  #user_profile > .button-group-header > .button-group {
    margin-right: auto;
  }

  .etab-actuel {
    display: flex;
    align-items: center;
    margin-right: var.$space-tiny;
    font-size: var.$font-regular;

    .country {
      text-transform: capitalize;
    }

    .separator {
      margin: 0 var.$space-x-tiny;
    }

    button {
      margin-left: var.$space-x-tiny;
    }
  }
}
</style>
